/**
 * Created by vtbelo on 17/03/21
 */

const PixelsPlanner = function (slot) {
    this.slot = slot;

    this.stored = this.slot.load("local_pixel_planner");

    this.onCreatePixel = function () {};

    this.init();
};

PixelsPlanner.prototype.destructor = function () {
    clearTimeout(this.timeout);
    this.timeout = undefined;
    this.inited = false;
};

PixelsPlanner.prototype.restart = function () {
    if (!this.inited) {
        return;
    }

    this.level = 0;
    this.save();

    if (this.timeout !== undefined) {
        this.planNextSwarm();
    }
};

PixelsPlanner.prototype.isAvailable = function () {
    const availablesCheck = cleverapps.user.checkAvailable(cleverapps.config.availables.PIXELS);
    if (!availablesCheck) {
        return false;
    }

    const available = PixelsPlanner.AVAILABLE[cleverapps.meta.selectedLocationId()];
    if (!available) {
        return false;
    }

    if (available.fog && !Map2d.currentMap.fogs.isOpened(available.fog)) {
        return false;
    }

    return true;
};

PixelsPlanner.prototype.init = function () {
    if (this.inited || cleverapps.config.editorMode || cleverapps.config.adminMode) {
        return;
    }

    if (!this.isAvailable()) {
        clearTimeout(this.timeout);
        this.timeout = new cleverapps.LongTimeout(this.init.bind(this), cleverapps.parseInterval(PixelsPlanner.BETWEEN_INIT_TIMEOUT));
        return;
    }

    this.inited = true;

    if (this.stored) {
        this.level = this.stored.level || 0;
        this.time = Math.min(this.stored.time || 0, Date.now());

        if (Date.now() > this.time + cleverapps.parseInterval(PixelsPlanner.CLEAR_TIMEOUT)) {
            this.level = 0;
            this.time = Date.now();
        }
    } else {
        this.level = 2;
        this.time = Date.now();
        this.firstTime = true;
    }

    this.save();
    this.planNextSwarm();
};

PixelsPlanner.prototype.save = function (force) {
    if (!this.inited && !force) {
        return;
    }

    this.slot.save("local_pixel_planner", {
        level: this.level,
        time: this.time
    });
};
PixelsPlanner.prototype.createSwarm = function (options) {
    if (!this.inited) {
        return;
    }

    options = options || { amount: PseudoRandom.GET().choose(PixelsPlanner.LEVELS[this.level].amount) };

    new PixelsSwarm(this, options);
};

PixelsPlanner.prototype.nextLevel = function () {
    if (this.level < PixelsPlanner.LEVELS.length - 1) {
        this.level++;
    }

    this.time = Date.now();
    this.save();
};

PixelsPlanner.prototype.startCurrentLevel = function () {
    if (!this.inited || this.timeout !== undefined) {
        return;
    }

    this.time = Date.now();
    this.save();

    this.planNextSwarm();
};

PixelsPlanner.prototype.planNextSwarm = function () {
    let waitTime = PixelsPlanner.LEVELS[this.level].timeout;
    if (this.firstTime) {
        this.firstTime = undefined;
        waitTime = PixelsPlanner.FIRST_TIMEOUT;
        if (cleverapps.unitsLibrary.listAvailableByType("fruit").length > 2 && PixelsPlanner.FIRST_LONG_TIMEOUT[cleverapps.meta.selectedLocationId()]) {
            waitTime = PixelsPlanner.FIRST_LONG_TIMEOUT[cleverapps.meta.selectedLocationId()];
        }
    }

    clearTimeout(this.timeout);
    this.timeout = new cleverapps.LongTimeout((() => {
        this.timeout = undefined;
        this.createSwarm();
    }), this.time + cleverapps.parseInterval(waitTime) - Date.now());
};

PixelsPlanner.LEVELS = [{
    amount: [4, 5, 5, 6],
    timeout: "30 seconds"
}, {
    amount: [3, 4],
    timeout: "3 minutes"
}, {
    amount: [2, 3, 3, 4],
    timeout: "4 minutes"
}, {
    amount: [2, 3],
    timeout: "5 minutes"
}, {
    amount: [2],
    timeout: "10 minutes"
}];

PixelsPlanner.AVAILABLE = {
    main: {}
};

PixelsPlanner.BETWEEN_INIT_TIMEOUT = "30 seconds";
PixelsPlanner.FIRST_TIMEOUT = "2 minutes";
PixelsPlanner.FIRST_LONG_TIMEOUT = {
    main: "10 minutes"
};
PixelsPlanner.CLEAR_TIMEOUT = "1 hour";
